import React, { useState } from 'react';

import { StudentCard, StudentInfoMenu, Readmore } from '../../components';
import { useSiteQuery } from '../../hooks';
import { renderPageContent } from '../../lib/ContentRenderer';
import { LinkField, urlFor } from '../../lib/Link';
import ErrorPage from '../_error';

import query from './index.graphql';
import styles from "@/components/Hero/styles.module.scss";
import readmoreStyles from "@/components/buttons/Readmore/styles.module.scss";
import cc from "classcat";

const renderHeroEntry = (entry: PageEntryContentFragment) => (
  <>
    {entry.hero?.[0] && (
      <div className="sectionWrapper">
        <div className="pageBanner">
          <div className={cc([
              'container',
            [styles[entry?.hero[0]?.backgroundColourHero || 'backgroundOrange']],
              styles.relativeContainer
          ])}>
            {entry.hero[0].customTitle && (
                <h1>{entry.hero[0].customTitle}</h1>
            )}
            {entry.hero[0].headline && (
                <p>{entry.hero[0].headline}</p>
            )}
            {entry.hero[0].simpleText && (
                <div className={styles.heroIntroduction} dangerouslySetInnerHTML={{ __html: entry.hero[0].simpleText! }} />
            )}
            {entry.hero[0].children && entry.hero[0].children.length > 0 && (
                <div className={styles.ctaHolder}>
                  {entry.hero[0].children.map((child) => {
                    if (!child) return null;
                    const linkField = child.linkField?.[0] as LinkField;
                    if (!linkField) return null;
                    const url = urlFor(linkField);
                    const backgroundClass = child.backgroundColourHero ? readmoreStyles[child.backgroundColourHero] : undefined;
                    return (
                      <Readmore
                        key={child.customTitle}
                        text={child.customTitle || undefined}
                        href={url}
                        className={backgroundClass}
                      />
                    );
                  })}
                </div>
            )}
            <div className={cc([ styles.heroBackground, 'bannerHeroBackgroundCustom' ])}>
              <svg className={styles.svgOverlay} preserveAspectRatio="none" viewBox="0 0 732 542" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 541.5V0H732C688.5 20.6667 572.607 97.6433 429.5 205.5C293.5 308 264.5 336 174.5 470.5C129.961 537.061 87 537 63.5 541.5H0Z" fill="inherit"/>
              </svg>
              <div className={styles.whiteUnderlay}>
                {/* overlaid colours use transparency */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </>
);

const renderPageEntry = (entry: PageEntryContentFragment) => (
  <>{entry.pageContent?.map((row) => renderPageContent(row!, false, entry))}</>
);

const StudentInformation = () => {
  const [activeFilter, setActiveFilter] = useState('');
  const [{ data, error }] = useSiteQuery<StudentInformationsQuery>({ query });

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  const entry = data?.entry;
  const entries = data?.entries;

  const filtered = entries?.filter(
    (item) => !activeFilter || (activeFilter && item?.studentInformationCategory?.[0]?.slug === activeFilter),
  );
  return (
    <div>
      {entry?.__typename === 'pages_pages_Entry' && renderHeroEntry(entry)}
      <div className="section">
        <div className="container">
          <StudentInfoMenu handleClick={(item: string) => setActiveFilter(item)} />
          <div className="row cardsWrapper mobileList">
            {filtered?.map((item) => item && <StudentCard key={item.uid!} item={item} />)}
          </div>
        </div>
      </div>
      {entry?.__typename === 'pages_pages_Entry' && renderPageEntry(entry)}
    </div>
  );
};

export default StudentInformation;
